"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Academy___StyledSvg",
  componentId: "ump8nt-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function Academy(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.308 9.76h.91v.985h-.91V9.76zm15.258-4.084l-6.998-3.583a1.088 1.088 0 00-.88 0L2.25 5.901v3.025h.985V6.443l1.97 1.086v3.413h.001l.002.944-.004.024.004-.001v.545c0 2.552 2.955 5.546 4.924 5.546 1.969 0 4.923-2.994 4.923-5.546 0-.708.023-3.594.012-4.933l2.507-1.382c.238-.132.234-.34-.008-.465v.002zM6.125 7.756c1.03-.262 2.384-.422 3.874-.422 1.491 0 2.846.16 3.875.421v1.102c-1.027-.263-2.38-.426-3.875-.426-1.494 0-2.845.163-3.874.426V7.755zm7.75 3.527c-.004.483-.006.878-.006 1.079 0 1.893-2.56 4.115-3.873 4.115-1.312 0-3.872-2.222-3.872-4.115v-.697c.85-.34 1.54-1.085 1.9-2.046.844.886 2.622 1.498 4.687 1.498.403 0 .788-.03 1.163-.077v.243zm-5.328.448a.489.489 0 00-.485.493.49.49 0 00.485.493.488.488 0 00.484-.493.488.488 0 00-.484-.493zm2.906 0a.49.49 0 00-.484.493.49.49 0 00.484.493.488.488 0 00.485-.493.488.488 0 00-.485-.493z",
    fill: "currentColor"
  }));
}

var _default = Academy;
exports["default"] = _default;